module.exports = __webpack_public_path__ + "assets/img/thumb-Coolabah-Turf-Service-Page.2f145f80.webp";